import React from 'react';
import type { GestureResponderEvent } from 'react-native';
import { StyleSheet } from 'react-native';
import { TextLink, theme } from '@sweetgreen/garnish';

export type AccountMenuSecondaryItemProps = Readonly<{
  testID: string;
  label: string;
  onPress: (event: GestureResponderEvent) => void;
  active?: boolean;
  disabled?: boolean;
}>;

export const AccountMenuSecondaryItem = ({
  testID,
  label,
  onPress,
}: AccountMenuSecondaryItemProps) => {
  return (
    <TextLink
      testID={testID}
      style={styles.textLink}
      underline={false}
      onPress={onPress}
    >
      {label}
    </TextLink>
  );
};

const styles = StyleSheet.create({
  textLink: {
    color: theme.colors.DARK_KALE,
    marginVertical: theme.spacing['2'],
  },
});
